import React, { FunctionComponent } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Box } from '@rebass/emotion';
import styled from '@emotion/styled';

import { StatusLabel, SummaryContainer, SummaryItem } from './Summary.styles';
import messages from './Summary.messages';

import { useOrderHistoryDetail } from './OrderHistoryDetailContext';

const Summary: FunctionComponent = () => {
  const { itemsData } = useOrderHistoryDetail();

  return itemsData ? (
    <SummaryContainer>
      <SummaryItem alignItems="center" py={3}>
        <Label width={[1, 1 / 4]}>
          <FormattedMessage {...messages.orderId} />
        </Label>
        <Box width={[1, 3 / 4]}>{itemsData.number}</Box>
      </SummaryItem>

      <SummaryItem alignItems="center" py={3}>
        <Label width={[1, 1 / 4]}>
          <FormattedMessage {...messages.orderDate} />
        </Label>
        <Box width={[1, 3 / 4]}>
          <FormattedDate
            year="2-digit"
            month="2-digit"
            day="numeric"
            value={new Date(itemsData.orderDate)}
          />
        </Box>
      </SummaryItem>

      <SummaryItem alignItems="center" py={3}>
        <Label width={[1, 1 / 4]}>
          <FormattedMessage {...messages.orderStatus} />
        </Label>
        <Box width={[1, 3 / 4]}>
          <StatusLabel>{itemsData.status}</StatusLabel>
        </Box>
      </SummaryItem>
    </SummaryContainer>
  ) : null;
};

export default Summary;

const Label = styled(Box)`
  font-weight: bold;

  &::after {
    content: ':';
  }
`;
